export function trackEvent(eventName, params = {}) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, {
      send_to: 'AW-11468865441',
      ...params,
    });
  }
}

export function trackPhoneCall(location) {
  trackEvent('contact', {
    event_category: 'Phone Call',
    event_label: location,
    method: 'phone',
  });
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', {
      send_to: 'AW-11468865441/8G9lCPnTo7IcEKH_49wq',
    });
  }
}

export function trackQuoteClick(location) {
  trackEvent('generate_lead', {
    event_category: 'Quote Request',
    event_label: location,
  });
}

export function trackLeadFormConversion() {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', {
      send_to: 'AW-11468865441/A1FMCNivoqIcEKH_49wq',
    });
  }
  if (typeof window.axon === 'function') {
    window.axon('event', 'lead', { event_data: { value: 1, currency: 'USD' } });
  }
}

export function trackBookingConversion(service) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', {
      send_to: 'AW-11468865441/A1FMCNivoqIcEKH_49wq',
    });
  }
  if (typeof window.axon === 'function') {
    window.axon('event', 'lead', { event_data: { value: 1, currency: 'USD' } });
  }
}

export function trackReviewSubmit(rating) {
  trackEvent('conversion', {
    event_category: 'Review',
    event_label: `${rating}-star review`,
    value: rating,
  });
}
